
import "./RegPartners.css";
const RegPartners = () => {
  return (
    <>
      <section className="rg-partners-main bg-main">
        <div className="container-fluid  rg-partners-line py-5">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-4">
                <img
                  src="https://goodhand.b-cdn.net/Assets/Registration/Apps%20(1).svg"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-md-7 my-auto">
                <div>
                  <h2 className="text-center text-md-start font-30 font-snm-25 mt-2 mt-md-0 text-white ff-bold mb-3">
                    Authorized Partner Services
                  </h2>

                  <p className="font-16 text-white mb-2  text-center text-md-start ">
                    As an authorized federal partner, Goodhand simplifies access
                    to essential government services, ensuring smooth
                    application management, real-time tracking, and timely
                    updates for a secure and efficient experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RegPartners;
